import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "mx-auto max-w-2xl lg:max-w-7xl" }

import type { InfoNoteElementProps } from "./InfoNoteElementProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";
import { computed } from "vue";
import HorizontalSpacing from "@/views/blocks/shared/section/layout/spacing/HorizontalSpacing.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoNoteElement',
  props: {
    block: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollAnimation, { type: _ctx.scrollAnimationType }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: _ctx.block.webId,
        style: _normalizeStyle({
                backgroundColor: styleValues.value.background,
            })
      }, [
        _createVNode(HorizontalSpacing, {
          class: _normalizeClass([
                    dataValues.value.formatting.data.paddingTop,
                    dataValues.value.formatting.data.paddingBottom,
                ])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!dataValues.value.infoNote.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "infoNote"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center gap-2", [
                                dataValues.value.formatting.data.elementAlign,
                                dataValues.value.formatting.data.maxWidth,
                                dataValues.value.formatting.data.textSize,
                                dataValues.value.formatting.data.justifyContent,
                            ]]),
                        style: _normalizeStyle({
                                color: styleValues.value.text,
                            })
                      }, [
                        _cache[0] || (_cache[0] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20",
                          fill: "currentColor",
                          "aria-hidden": "true",
                          class: "w-5 h-5 flex-none"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)),
                        _createVNode(Paragraph, {
                          text: dataValues.value.infoNote.data.text,
                          "text-color": styleValues.value.text,
                          class: "opacity-70"
                        }, null, 8, ["text", "text-color"])
                      ], 6)
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 12, _hoisted_1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})